import { Component, Inject, Input, OnDestroy } from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseComponent } from '@ridango/core';
import Env, { PRODUCT_AREA_DISPLAY_OPTION } from '@ridango/core/env';
import { ApplicationFacade } from '@ridango/components';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'rwidget-ticket-details-zone-map',
    templateUrl: './ticket-details-zone-map.component.html',
    styleUrls: ['./ticket-details-zone-map.component.scss']
})
export class TicketDetailsZoneMapComponent extends BaseComponent implements OnDestroy {
    @Input() imageSrc: string | null = null;
    @Input() set localizedMapSrc(value: string | null) {
        this.localizedMapSrc$.next(value);
    }

    readonly slideOptions = {
        zoom: true,
        allowSlideNext: false,
        allowSlidePrev: false
    };

    readonly PRODUCT_AREA_DISPLAY_OPTION = PRODUCT_AREA_DISPLAY_OPTION;
    readonly productAreaDisplayOption =
        this.env.AREA_MAP?.PRODUCT_AREA_DISPLAY_OPTION ?? PRODUCT_AREA_DISPLAY_OPTION.FULL_MAP;

    private readonly localizedMapSrc$ = new BehaviorSubject<string | null>(null);

    readonly mapSrc$ = combineLatest([this.applicationFacade.assetsPath$, this.localizedMapSrc$]).pipe(
        map(([assetsPath, localizedSrc]) => {
            if (localizedSrc) {
                return localizedSrc;
            }
            if (this.productAreaDisplayOption === PRODUCT_AREA_DISPLAY_OPTION.SPLIT_AREA) {
                return this.imageSrc ?? `${assetsPath}/img/purchase-flow-v2/product-area/areas-map.png`;
            }
            return this.env.AREA_MAP?.SVG_IMAGE_SRC ?? `${assetsPath}/img/purchase-flow-v2/product-area/areas-map.png`;
        })
    );

    constructor(
        @Inject('ENV') private readonly env: Env,
        private readonly applicationFacade: ApplicationFacade,
        private readonly modalCtrl: ModalController
    ) {
        super();
    }

    async cancel(): Promise<void> {
        await this.modalCtrl.dismiss(null, 'cancel');
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
